// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';

import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import moment from 'moment';
import 'moment/locale/en-gb';

// import axios from 'axios';
// import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';
import * as serviceWorker from './serviceWorker';
import { store } from './store';
import App from './App';

const firebaseConfig = {
  apiKey: 'AIzaSyCwWfvt-qxt2s-Ev_M2VQuGqsH_uaTXFIc',
  authDomain: 'sellitback-ca04f.firebaseapp.com',
  databaseURL: 'https://sellitback-ca04f.firebaseio.com',
  projectId: 'sellitback-ca04f',
  storageBucket: 'sellitback-ca04f.appspot.com',
  messagingSenderId: '466383168670',
  appId: '1:466383168670:web:40129d605b56ea1cd7078f',
  measurementId: 'G-BCZREZS0GC'
};

// Every date on the site is British: dd/mm/yyyy. Most are spelled out at the
// point of use, but moment's own localised formats ('L', 'LL', and the like)
// follow whichever locale is active, and the built-in default is American -
// which is how a voucher issued on 14 September came to read 09/14/2026.
// Setting it once here means the short form is right wherever it is reached
// for. (The date picker is react-datepicker on date-fns, not moment, and is
// unaffected by this.)
moment.locale('en-gb');

firebase.initializeApp(firebaseConfig);
firebase.analytics();

// const postMessageToSlack = (exeptionInfo) => {
//   const url = 'https://hooks.slack.com/services/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';
//   const sentryUrl = 'https://celadonsoft-qc.sentry.io/issues/?project=4504690485952512';

//   const message = {
//     blocks: [
//       {
//         type: 'header',
//         text: {
//           type: 'plain_text',
//           text: `${exeptionInfo} :sos:`,
//           emoji: true
//         }
//       },
//       {
//         type: 'section',
//         text: {
//           type: 'mrkdwn',
//           text: `Follow the link to see the details. <${sentryUrl}|Issues>`
//         }
//       }
//     ]
//   };

//   axios.post(url, JSON.stringify(message));
// };

// Sentry.init({
//   dsn:
//   'https://f64ec5f6f4ef40f2a7acf695c2a860f8@o4504690460262400.ingest.sentry.io/4504690485952512',
//   integrations: [new BrowserTracing()],
//   // eslint-disable-next-line no-unused-vars
//   beforeSend(event, hint) {
//     // Check if it is an exception, and if so, show the report dialog
//     if (event.exception) {
//     const exeptionInfo = `${event.exception.values[0].type}: ${event.exception.values[0].value}`;
//       postMessageToSlack(exeptionInfo);
//     }

//     return event;
//   },

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0,
// });

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
